import { render, staticRenderFns } from "./copy-maschine-wizard.vue?vue&type=template&id=23b14026"
import script from "./copy-maschine-wizard.vue?vue&type=script&lang=js"
export * from "./copy-maschine-wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports